(() => {
  function initMegaMenuDesktop() {
    const triggerItems = document.querySelectorAll('.list-menu--megamenu');
    if (!triggerItems.length) return;

    // Use the visual bottom of the header nav bar itself (most reliable)
    function getHeaderBottom() {
      const candidates = [
        '.header',
        '.shopify-section-group-header-group',
        '.shopify-section-header',
      ];
      let max = 0;
      for (const sel of candidates) {
        const el = document.querySelector(sel);
        if (el) max = Math.max(max, el.getBoundingClientRect().bottom);
      }
      return max;
    }

    function positionMenu(menu) {
      menu.style.top = getHeaderBottom() + 'px';
    }

    const headerSection = document.querySelector('.shopify-section-header');
    let savedHeaderState = null;
    let blockLeave = null;

    function setHeaderSolid() {
      if (!headerSection) return;
      savedHeaderState = {
        hasBg2: headerSection.classList.contains('color-background-2'),
        hasHaveBg: headerSection.classList.contains('have-background'),
      };
      headerSection.classList.remove('color-background-2');
      headerSection.classList.add('have-background');

      // Prevent header.js's mouseleave listener from undoing these classes
      // while the mega menu is open. Capture phase fires before header.js's
      // bubble-phase listener, so stopImmediatePropagation blocks it.
      if (!blockLeave) {
        blockLeave = (e) => e.stopImmediatePropagation();
        headerSection.addEventListener('mouseleave', blockLeave, true);
      }
    }

    function restoreHeader() {
      if (!headerSection || !savedHeaderState) return;
      if (savedHeaderState.hasBg2) headerSection.classList.add('color-background-2');
      if (!savedHeaderState.hasHaveBg) headerSection.classList.remove('have-background');
      savedHeaderState = null;

      if (blockLeave) {
        headerSection.removeEventListener('mouseleave', blockLeave, true);
        blockLeave = null;
      }
    }

    function closeAll() {
      document.querySelectorAll('[data-mega-menu].is-open').forEach((m) => {
        m.classList.remove('is-open');
        m.setAttribute('aria-hidden', 'true');
      });
      restoreHeader();
    }

    triggerItems.forEach((item) => {
      const menu = item.querySelector('[data-mega-menu]');
      if (!menu) return;

      const trigger = item.querySelector('.header__menu-item');
      if (!trigger) return;

      // Teleport out of the will-change:transform container so position:fixed
      // is relative to the true viewport
      document.body.appendChild(menu);

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (menu.classList.contains('is-open')) {
          closeAll();
        } else {
          positionMenu(menu);
          menu.classList.add('is-open');
          menu.setAttribute('aria-hidden', 'false');
          setHeaderSolid();
        }
      });

      // Clicks inside the panel stay open; links inside navigate normally
      menu.addEventListener('click', (e) => e.stopPropagation());
    });

    // Close when clicking anywhere outside
    document.addEventListener('click', closeAll);

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    // Close on scroll
    window.addEventListener('scroll', closeAll, { passive: true });

    // Reposition on resize only (not scroll, since we close on scroll)
    window.addEventListener('resize', () => {
      document.querySelectorAll('[data-mega-menu].is-open').forEach(positionMenu);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuDesktop);
  } else {
    initMegaMenuDesktop();
  }
})();
